import createIcon from '../../createIcon';

/**
 * @component @name Nightlife
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMS41IDQuNUgxNS41TDkuNSAxMy41VjE3LjVIMTEuNVYxOS41SDUuNVYxNy41SDcuNVYxMy41TDEuNSA0LjVaTTEwLjYgOC41TDEyIDYuNUg0Ljk5TDYuMzkgOC41SDEwLjZaTTE3LjUgNC41SDIyLjVWNy41SDE5LjVWMTYuNUMxOS41IDE4LjE2IDE4LjE2IDE5LjUgMTYuNSAxOS41QzE0Ljg0IDE5LjUgMTMuNSAxOC4xNiAxMy41IDE2LjVDMTMuNSAxNC44NCAxNC44NCAxMy41IDE2LjUgMTMuNUMxNi44NSAxMy41IDE3LjE5IDEzLjU2IDE3LjUgMTMuNjdWNC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Nightlife = createIcon('Nightlife', [
  [
    'path',
    {
      d: 'M1.5 4.5H15.5L9.5 13.5V17.5H11.5V19.5H5.5V17.5H7.5V13.5L1.5 4.5ZM10.6 8.5L12 6.5H4.99L6.39 8.5H10.6ZM17.5 4.5H22.5V7.5H19.5V16.5C19.5 18.16 18.16 19.5 16.5 19.5C14.84 19.5 13.5 18.16 13.5 16.5C13.5 14.84 14.84 13.5 16.5 13.5C16.85 13.5 17.19 13.56 17.5 13.67V4.5Z',
      key: '18vpaz',
    },
  ],
]);

export default Nightlife;
